module.exports = __webpack_public_path__ + "static/media/projects_thumb_bkst_logo_2x.4d9c8ad8.jpg";